import { SyntheticEvent } from 'react'

/**
 * Returns an `<img>` onError handler that swaps the source to `fallbackSrc`.
 *
 * A business image URL served from the directory points at the backend
 * `view-file?fileHash=<hash>` endpoint; when that image was deleted the URL
 * 404s. Without this handler the browser shows a broken-image icon (the
 * component only renders the default image when the field is empty, not on a
 * failed load). This degrades a failed load to the existing default asset.
 *
 * Guarded so the fallback is applied at most once, preventing an infinite
 * error loop if the fallback asset itself fails to load.
 */
export const imageErrorFallback =
  (fallbackSrc: string) =>
  (event: SyntheticEvent<HTMLImageElement>): void => {
    const img = event.currentTarget
    if (img.dataset.fallbackApplied === 'true') {
      return
    }
    img.dataset.fallbackApplied = 'true'
    img.src = fallbackSrc
  }
